import gql from "graphql-tag";

export const GET_BULK_PRICE_DATA = gql`
    query GetBulkPriceData {
        AllLinks(lang: "cz", isEshopCategory: 1, onlyActive: true) {
            linkID
            name
            subLinks {
                linkID
                name
            }
        }
        AllManufacturers(lang: "cz", offset: 0, limit: 10000) {
            manufacturerID
            name
        }

        AllLanguageMutations(onlyEnabled: true) {
            languageID
            title
            suffix
            generateNiceTitle
            langTitle
            decimal
            priority
            main
            currencyTitle
        }
    }
`;

export const GET_BULK_PRICE_EDIT_PRODUCTS_BY_LINK = gql`
    query AllProducts($lang: String, $linkID: ID) {
        AllProducts(lang: $lang, limit: 10000, offset: 0, searchText: "", linkID: $linkID) {
            productID
            name
            price
            commonPrice
            discount
            isDiscountPercentage
            variants {
                productVariantID
                name
                productCode
                price
                commonPrice
                discount
                isDiscountPercentage
            }
        }
    }
`;

export const GET_BULK_PRICE_EDIT_PRODUCTS_BY_MANUFACTURER = gql`
    query AllProducts($lang: String, $filters: ProductFilters) {
        AllProducts(lang: $lang, limit: 10000, offset: 0, searchText: "", linkID: 0, filters: $filters) {
            productID
            name
            price
            commonPrice
            discount
            isDiscountPercentage
            manufacturerID
            variants {
                productVariantID
                name
                productCode
                price
                commonPrice
                discount
                isDiscountPercentage
            }
        }
    }
`;

export const BULK_EDIT_PRODUCT_PRICE = gql`
    mutation BulkEditProductPrice($id: ID, $productType: String, $isPercentage: Int, $operationType: String, $value: String) {
        BulkEditProductPrice(id: $id, productType: $productType, isPercentage: $isPercentage, operationType: $operationType, value: $value)
    }
`;
